import { cn } from "lib/utils";
import React from "react";

export const Stepper: React.FC<{ currentStep?: number }> = ({
	currentStep = 1,
}) => (
	<div
		className={cn(
			"flex w-full flex-col gap-3 pb-6 max-[639px]:gap-2 max-[639px]:pb-4",
		)}
	>
		<p
			className={cn(
				"w-full font-sans text-[16px] font-bold uppercase tracking-[0.8px] text-[#45556C] max-[639px]:text-[11px] max-[639px]:tracking-[0.5px]",
			)}
		>
			Etapa {currentStep} de 4
		</p>
		<div className={cn("flex w-full gap-[10px] max-[639px]:gap-1")}>
			{[1, 2, 3, 4].map((step) => (
				<span
					key={step}
					className={cn(
						"h-7 flex-1 max-[639px]:h-4",
						step <= currentStep ? "bg-[#2B7FFF]" : "bg-[#CAD5E2]",
					)}
				/>
			))}
		</div>
	</div>
);
